export default [{
  text: '',
  items: [
    { icon: 'mdi-view-dashboard-outline', key: 'menu.dashboard', text: 'Dashboard', link: '/dashboard'  },
    { icon: 'mdi-receipt', key: 'menu.blank', text: 'Ledger', link: '/ledger' },
    { icon: 'mdi-history', key: 'menu.blank', text: 'Transaction History', link: '/RRRtransactionhistory' },
    //{ icon: 'mdi-bell', key: 'menu.blank', text: 'Notification', link: '/notification' } ,
    { icon: 'mdi-logout', key: 'menu.blank', text: 'Logout', link: '/logout' }  
  ]
}]